import React from 'react';
import { useEffect } from 'react';
import PaymentMethodForm from 'src/components/PaymentMethodForm';
import {
  Modal,
  ModalBody,
  ModalHeader,
  toast,
  useApp,
  useStateIn
} from 'straightline-ui';

export default function PaymentModal({ open, title, onSuccess, onCancel }) {
  return (
    <div>
      <Modal isOpen={open} size="md">
        {() => (
          <Content title={title} onSuccess={onSuccess} onCancel={onCancel} />
        )}
      </Modal>
    </div>
  );
}

function Content({ title, onSuccess, onCancel }) {
  const app = useApp();
  const {
    state: { clientSecret, intentLoading },
    assignState
  } = useStateIn({
    clientSecret: null,
    intentLoading: true
  });

  useEffect(() => {
    const fetchPaymentIntent = async () => {
      try {
        const intent = await app
          .service('api/payment-methods/setup')
          .create({});
        assignState({
          clientSecret: intent.client_secret,
          intentLoading: false
        });
      } catch (error) {
        toast.error(
          `There was an issue creating your payment method: ${error.message}`
        );
      }
    };

    fetchPaymentIntent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSuccess = async (setupIntent) => {
    app
      .service('api/payment-methods')
      .create({
        stripe_id: setupIntent.payment_method
      })
      .then((paymentMethod) => {
        onSuccess(paymentMethod);
      })
      .catch((error) => {
        toast.error(
          `There was an issue linking your payment method: ${error.message}`
        );
      });
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleError = (error) => {
    toast.error(
      `There was an issue linking your payment method: ${error.message}`
    );
  };

  return (
    <React.Fragment>
      {title && (
        <ModalHeader>
          <h2 className="modal-title">{title}</h2>
        </ModalHeader>
      )}
      <ModalBody>
        <div
          style={{ minHeight: 427 }}
          className={intentLoading ? 'is-loading' : ''}
        >
          {clientSecret && (
            <PaymentMethodForm
              clientSecret={clientSecret}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
              onError={handleError}
            />
          )}
        </div>
      </ModalBody>
    </React.Fragment>
  );
}
